import { styled } from '@goodfynd/react-web.theme';

export const StyledLabel = styled('span', {
  display: 'flex',
  justifyContent: 'space-between',
});
